import React, { useState } from 'react';
import './NewProjectDialog.css';
import './Button.css';

const NewProjectDialog = ({ onSave, onCancel, isCreating }) => {
  const [projectName, setProjectName] = useState('');
  const [error, setError] = useState('');

  const handleSave = () => {
    if (projectName.trim() === '') {
      setError('Project name cannot be empty.');
    } else {
      onSave(projectName);
    }
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <h3>New Project</h3>
        <div className="form-group">
          <input
            type="text"
            value={projectName}
            onChange={(e) => {
              setProjectName(e.target.value);
              if (error) {
                setError('');
              }
            }}
            placeholder="Enter project name"
            className={`project-name-input ${error ? 'input-error' : ''}`}
            disabled={isCreating}
          />
          {error && <p className="error-message">{error}</p>}
        </div>
        <div className="dialog-buttons">
          <button onClick={onCancel} className="btn-red-borderless" disabled={isCreating}>Cancel</button>
          <button onClick={handleSave} className="btn-teal" disabled={isCreating}>
            {isCreating ? <div className="spinner"></div> : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewProjectDialog;
